import axios, { AxiosInstance } from 'axios';
import createClientAxios from './axios-client';
import createServerAxios from './axios-server';

axios.defaults.timeout = 15000;
axios.defaults.xsrfHeaderName = 'x-csrf-token';
axios.defaults.xsrfCookieName = 'csrfToken';

const axiosInstance: any = EASY_ENV_IS_NODE ? () => createServerAxios() : (param) => createClientAxios(param);

export default axiosInstance;
